import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function validateDocument(type, number) {
  const n = (number || "").trim();
  if (!type) return "Selecciona el tipo de documento";
  if (!n) return "El número de documento es obligatorio";
  if (type === "cedula") {
    if (!/^\d+$/.test(n)) return "La cédula solo puede contener números";
    if (n.length !== 11) return `La cédula debe tener exactamente 11 dígitos (tiene ${n.length})`;
  } else if (!/^[A-Za-z0-9]{3,20}$/.test(n)) {
    return "El pasaporte solo puede contener letras y números (3 a 20 caracteres)";
  }
  return null;
}

export default function DocumentFields({ type, number, onChange, disabled = false, prefix = "doc" }) {
  const clean = (v) => (type === "cedula" ? v.replace(/\D/g, "").slice(0, 11) : v.replace(/[^A-Za-z0-9]/g, "").slice(0, 20));
  const len = (number || "").length;
  const cedulaHint = type === "cedula" && len > 0 && len !== 11
    ? `La cédula debe tener exactamente 11 dígitos (llevas ${len})`
    : null;

  return (
    <div className="grid grid-cols-[140px_1fr] gap-3" data-testid={`${prefix}-fields`}>
      <div>
        <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Documento *</Label>
        <Select value={type} onValueChange={(v) => onChange({ type: v, number: "" })} disabled={disabled}>
          <SelectTrigger className="mt-1.5 rounded-xl border-[#E2E8F0] font-bold" data-testid={`${prefix}-type-select`}>
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="cedula">Cédula</SelectItem>
            <SelectItem value="pasaporte">Pasaporte</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Número *</Label>
        <Input
          value={number}
          disabled={disabled || !type}
          inputMode={type === "cedula" ? "numeric" : "text"}
          placeholder={type === "cedula" ? "11 dígitos, sin guiones" : type ? "Letras y números" : "Elige el tipo primero"}
          onChange={(e) => onChange({ type, number: clean(e.target.value) })}
          className="mt-1.5 rounded-xl border-[#E2E8F0]"
          data-testid={`${prefix}-number-input`}
        />
        {cedulaHint && <p className="mt-1 text-xs font-bold text-red-500" data-testid={`${prefix}-number-error`}>{cedulaHint}</p>}
      </div>
    </div>
  );
}
